// ============================================================================
// tasks.instance.detail — migrated off the global read
// ============================================================================
// /tasks/<id>. The core remains one load: a Promise.all with a single catch,
// then a conditional fail-soft photo read. Its modal/gallery descendants have
// three separately timed interaction resources, so they are declared here but
// enabled only by those open/viewer boundaries.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'tasks.instance.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'tasks.instance.core', owner: 'permanent'}),
    Object.freeze({id: 'tasks.instance.interaction.photos', owner: 'permanent'}),
    Object.freeze({id: 'tasks.instance.dueDateHistory', owner: 'permanent'}),
    Object.freeze({id: 'tasks.instance.signedPhotoUrl', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
